import React from 'react'
import {Flex} from '@salesforce/retail-react-app/app/components/shared/ui'
import RecipeUtilityTile from './recipe-utility-tile'
import PropTypes from 'prop-types'

const RecipeSuggestionsBlocks = ({productsGroup, styles}) => {
    return (
        <Flex
            flexDir={{base: 'column', lg: 'row'}}
            justifyContent="center"
            alignItems="center"
            flex="1 0 0"
            gap="medium.base"
        >
            {productsGroup.map((product, idx) => (
                <RecipeUtilityTile
                    key={`main-item-${product?.id || idx}`}
                    styles={styles}
                    tile={product}
                    variant="white"
                />
            ))}
        </Flex>
    )
}

RecipeSuggestionsBlocks.propTypes = {
    productsGroup: PropTypes.array,
    styles: PropTypes.shape(),
}
export default RecipeSuggestionsBlocks
